import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { UserContext } from '../../contexts';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    width: '100%',
    position: 'relative',
    transition: '.1s filter linear',
    paddingTop: 0,
  },
  hideBlur: {
    height: 0,
  },
}));

const BlurScreen = ({ children, containerStyle, isBlurShown }) => {
  const classes = useStyles();
  const { isScreenCanBeActive, isAutoLogoutDialogOpen } = useSelector((state) => state.appSettings);
  const { changeAccountLoading } = useContext(UserContext);

  return (
    <div
      className={classes.container}
      style={{
        ...containerStyle,
        filter: isBlurShown || !isScreenCanBeActive || isAutoLogoutDialogOpen || changeAccountLoading ? 'blur(5px)' : null,
      }}>
      {children}
    </div>
  );
};

export default BlurScreen;
